import 'angular:locale/data:fr-CA';
import 'angular:locale/data:en-IE';
import 'angular:locale/data:en-CA';
import 'angular:locale/data:en-AU';
import 'angular:locale/data:en-GB';
import './src/ang2/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
